document.addEventListener('DOMContentLoaded', async () => {

  const feed = document.querySelector('.instagram-feed-grid');

  if (!feed) return;

  const token = feed.dataset.accessToken;
  const limit = parseInt(feed.dataset.postLimit || 8);

  if (!token) {
    feed.innerHTML = '<p>Add Instagram access token.</p>';
    return;
  }

  const endpoint = `https://graph.facebook.com/v23.0/${feed.dataset.userId}/media?fields=id,caption,media_type,media_url,permalink,thumbnail_url,timestamp,like_count,comments_count,comments{text,username},children{media_url,media_type}&access_token=${token}&limit=${limit}`;

  const modal = document.querySelector('.instagram-modal');

  const modalMedia = modal.querySelector('.instagram-modal__media');
  const modalCaption = modal.querySelector('.instagram-modal__caption');
  const modalLink = modal.querySelector('.instagram-modal__link');

  const modalLikes = modal.querySelectorAll('.instagram-modal__likes');
  const modalComments = modal.querySelectorAll('.instagram-modal__comments');

  const modalCommentsList = modal.querySelector('.instagram-modal__comments-list');

  const readMoreButton = modal.querySelector('.instagram-read-more');

  try {

    const response = await fetch(endpoint);

    const data = await response.json();

    if (!data.data) {

      feed.innerHTML = '<p>Could not load Instagram feed.</p>';

      return;

    }

    feed.innerHTML = '';

    data.data.forEach(post => {

      const item = document.createElement('div');

      item.className = 'instagram-feed-item';

      let media = '';

      if (
        post.media_type === 'CAROUSEL_ALBUM'
        && post.children
        && post.children.data
      ) {

        const firstMedia = post.children.data[0];

        media = `
          <img
            src="${firstMedia.media_url}"
            alt="Instagram post"
            loading="lazy"
          >

          <div class="instagram-feed-item__carousel">
            ⧉
          </div>
        `;

      } else if (post.media_type === 'VIDEO') {

        media = `
          <video
            muted
            playsinline
            loop
            preload="metadata"
          >
            <source
              src="${post.media_url}"
              type="video/mp4"
            >
          </video>

          <div class="instagram-feed-item__video">
            ▶
          </div>
        `;

      } else {

        media = `
          <img
            src="${post.media_url}"
            alt="Instagram post"
            loading="lazy"
          >
        `;

      }

      item.innerHTML = `
        ${media}

        <div class="instagram-feed-item__overlay">

          <div class="instagram-feed-item__stats">

            <span>
              ❤ ${post.like_count || 0}
            </span>

            <span>
              💬 ${post.comments_count || 0}
            </span>

          </div>

        </div>
      `;

      const video = item.querySelector('video');

      if (video) {

        item.addEventListener('mouseenter', () => {
          video.play();
        });

        item.addEventListener('mouseleave', () => {
          video.pause();
          video.currentTime = 0;
        });

      }

      item.addEventListener('click', () => {
        openModal(post);
      });

      feed.appendChild(item);

    });

  } catch (error) {

    console.error(error);

    feed.innerHTML = `
      <p>Error loading Instagram feed.</p>
    `;

  }

  function openModal(post) {

    modal.hidden = false;

    document.body.style.overflow = 'hidden';

    modalLikes.forEach(el => {
      el.innerHTML = `❤ ${post.like_count || 0}`;
    });

    modalComments.forEach(el => {
      el.innerHTML = `💬 ${post.comments_count || 0}`;
    });

    if (
      post.media_type === 'CAROUSEL_ALBUM'
      && post.children
      && post.children.data
    ) {

      const slides = post.children.data.map((media, index) => {

        if (media.media_type === 'VIDEO') {

          return `
            <div class="instagram-carousel-slide ${index === 0 ? 'active' : ''}">

              <video
                controls
                playsinline
              >
                <source
                  src="${media.media_url}"
                  type="video/mp4"
                >
              </video>

            </div>
          `;

        }

        return `
          <div class="instagram-carousel-slide ${index === 0 ? 'active' : ''}">

            <img
              src="${media.media_url}"
              alt=""
            >

          </div>
        `;

      }).join('');

      const dots = post.children.data.map((_, index) => {

        return `
          <div class="instagram-carousel-dot ${index === 0 ? 'active' : ''}"></div>
        `;

      }).join('');

      modalMedia.innerHTML = `
        <div class="instagram-carousel-wrapper">

          <button class="instagram-carousel-prev">
            ‹
          </button>

          <div class="instagram-carousel">
            ${slides}
          </div>

          <button class="instagram-carousel-next">
            ›
          </button>

          <div class="instagram-carousel-dots">
            ${dots}
          </div>

        </div>
      `;

    } else if (post.media_type === 'VIDEO') {

      modalMedia.innerHTML = `
        <video
          controls
          autoplay
          playsinline
        >
          <source
            src="${post.media_url}"
            type="video/mp4"
          >
        </video>
      `;

    } else {

      modalMedia.innerHTML = `
        <img
          src="${post.media_url}"
          alt="Instagram post"
        >
      `;

    }

    modalCaption.textContent = post.caption || '';

    const permalink = post.permalink
      ? `${post.permalink.replace(/\/$/, '')}/`
      : 'https://www.instagram.com/';

    modalLink.href = permalink;

    let commentsHtml = '';

    if (
      post.comments &&
      post.comments.data &&
      post.comments.data.length
    ) {

      commentsHtml = post.comments.data.map(comment => `
        <div class="instagram-comment">

          <strong>${comment.username}</strong>

          <p>${comment.text}</p>

        </div>
      `).join('');

      modalCommentsList.innerHTML = commentsHtml;

    } else {

      modalCommentsList.innerHTML = '';

    }

   const expandable = modal.querySelector('.instagram-modal__expandable');

expandable.classList.remove('is-expanded');

requestAnimationFrame(() => {

  if (window.innerWidth <= 749) {

    const needsExpand =
      expandable.scrollHeight > 260;

    if (needsExpand) {

      readMoreButton.style.display = 'inline-flex';

      readMoreButton.textContent = 'Lees meer';

      readMoreButton.onclick = () => {

        const expanded =
          expandable.classList.toggle('is-expanded');

        readMoreButton.textContent =
          expanded
            ? 'Lees minder'
            : 'Lees meer';

      };

    } else {

      readMoreButton.style.display = 'none';

    }

  } else {

    readMoreButton.style.display = 'none';

  }

});


    initCarousel();

  }

  function initCarousel() {

    const carousel = modal.querySelector('.instagram-carousel');

    if (!carousel) return;

    const slides = carousel.querySelectorAll('.instagram-carousel-slide');

    const dots = modal.querySelectorAll('.instagram-carousel-dot');

    let current = 0;

    const updateSlides = () => {

      slides.forEach((slide, index) => {

        slide.classList.toggle(
          'active',
          index === current
        );

      });

      dots.forEach((dot, index) => {

        dot.classList.toggle(
          'active',
          index === current
        );

      });

    };

    modal.querySelector('.instagram-carousel-next')
      ?.addEventListener('click', () => {

        current++;

        if (current >= slides.length) {
          current = 0;
        }

        updateSlides();

      });

    modal.querySelector('.instagram-carousel-prev')
      ?.addEventListener('click', () => {

        current--;

        if (current < 0) {
          current = slides.length - 1;
        }

        updateSlides();

      });

    let touchStartX = 0;
    let touchEndX = 0;

    carousel.addEventListener('touchstart', e => {

      touchStartX = e.changedTouches[0].screenX;

    });

    carousel.addEventListener('touchend', e => {

      touchEndX = e.changedTouches[0].screenX;

      if (touchEndX < touchStartX - 50) {

        current++;

        if (current >= slides.length) {
          current = 0;
        }

        updateSlides();

      }

      if (touchEndX > touchStartX + 50) {

        current--;

        if (current < 0) {
          current = slides.length - 1;
        }

        updateSlides();

      }

    });

  }

  function closeModal() {

    modal.hidden = true;

    document.body.style.overflow = '';

    modalMedia.innerHTML = '';

  }

  modal.querySelector('.instagram-modal__close')
    .addEventListener('click', closeModal);

  modal.querySelector('.instagram-modal__overlay')
    .addEventListener('click', closeModal);

  document.addEventListener('keydown', e => {

    if (e.key === 'Escape') {
      closeModal();
    }

  });

});